import React from "react";
import styled from "styled-components";
import { Link as ScrollLink } from "react-scroll";

export default function Contact() {
  const getCurrentYear = () => new Date().getFullYear();

  return (
    <Wrapper>
      <div className="darkBg">
        <div className="container">
          <InnerWrapper className="flexSpaceCenter" style={{ padding: "30px 0" }}>

            <ScrollLink to="home" smooth={true} offset={-80} role="link" aria-label="Scroll to top">
              <LogoBtn as="div" role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter') e.target.click(); }}>
                <LogoImgEl
                  src="/nava-logo.png"
                  alt="Nava Energy logo"
                  loading="lazy"
                  width={80}
                  height={50}
                />
                <div style={{ textAlign: "center" }}>
                  <h1 style={{ fontSize: "20px", fontWeight: 800, margin: 0, color: "#13365c" }}>NAVA</h1>
                  <h2 style={{ fontSize: "14px", fontWeight: 800, margin: 0, color: "#179fd6" }}>ENERGY</h2>
                </div>
              </LogoBtn>
            </ScrollLink>


            <StyleP className="whiteColor font13">
              © {getCurrentYear()} - <span className="purpleColor font13">Nava Energy</span> All Rights Reserved
            </StyleP>

            <ScrollLink className="whiteColor animate pointer font13" to="home" smooth={true} offset={-80}>
              Back to top
            </ScrollLink>
          </InnerWrapper>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
`;

const InnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 550px) {
    flex-direction: column;
    gap: 12px;
  }
`;

const StyleP = styled.p`
  margin: 0;
  @media (max-width: 550px) {
    margin: 20px 0;
  }
`;

const LogoBtn = styled.button`
  background: transparent;
  border: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding: 0;
`;

const LogoImgEl = styled.img`
  width: 80px;
  height: 50px;
  object-fit: contain;
  display: block;
  z-index: 2;
`;
